const getParentOrigin = () => {
  let url = ""
  const locationAreDisctint = (window.location !== window.parent.location);
  const parentOrigin = ((locationAreDisctint ? document.referrer : document.location) || "").toString();

  if (parentOrigin) {
    url = new URL(parentOrigin).origin;
  }

  const currentLocation = document.location;

  if (currentLocation.ancestorOrigins && currentLocation.ancestorOrigins.length) {
    url = currentLocation.ancestorOrigins[0];
  }

  if (url) {
    url = url.split("://");
    url.splice(0,1);
    url = url.join('');
  }

  return url;
}

const getCustomerPrefix = () => {
    const ignorePrefix = ['www', 'app', 'localhost', 'api'];
    const prefix = getParentOrigin().split('.')[0];
    return ignorePrefix.includes(prefix) ? 'app' : prefix;
  }
  
export const getBaseUrlWithCustomerPrefix = (baseUrl) => {
    const baseUrlSplited = baseUrl.split('//');
    const protocol = baseUrlSplited[0]+'//';
    baseUrlSplited.splice(0,1);
    const host = baseUrlSplited.join('//');
    return protocol+ getCustomerPrefix()+'.'+host;
  }